import {
  PaginatedEventRecurrence,
  QueryEventRecurrencesArgs,
} from '@tribeplatform/gql-client/types'
import { EventRecurrenceFields } from '@tribeplatform/gql-client/types/generated'

import { useInfiniteQuery, UseInfiniteQueryOptions } from '../../lib/index.js'
import { useTribeClient } from '../../useTribeClient.js'

import { getEventRecurrencesKey } from './event.key.js'

export const useEventRecurrences = (options: {
  variables: QueryEventRecurrencesArgs
  fields?: EventRecurrenceFields
  useInfiniteQueryOptions?: UseInfiniteQueryOptions<PaginatedEventRecurrence>
}) => {
  const { variables, fields = 'basic', useInfiniteQueryOptions } = options

  const { client } = useTribeClient()
  const eventRecurrencesKey = getEventRecurrencesKey({ variables, fields })

  return useInfiniteQuery(
    eventRecurrencesKey,
    ({ pageParam: after }) =>
      client.events.eventRecurrences({ ...variables, after }, fields),
    {
      ...useInfiniteQueryOptions,
    },
  )
}
